import shared from './shared'
import store from '../store'
import { ApplicationState } from '../application-state'

export default {
    shared,
    async fetchMetadata () {
        if (store.state.metadata.loaded === false) {
            let metadata = await this.shared.db().ref('/metadata').once('value')
            metadata = metadata.val()
            if (metadata) {
                store.state.metadata.poweredBy = metadata.poweredby
                store.state.metadata.partners = metadata.partners
            } else {
                store.state.metadata.poweredBy = false
                store.state.metadata.partners = false
            }
            try {
                const getMetadata = this.shared.functions().httpsCallable('getMetadata')
                let res = await getMetadata()
                store.state.metadata.userData.liga = res && res.data && res.data.obveznaLiga
                store.state.metadata.userData.name = res && res.data && res.data.name
                store.state.metadata.userData.vlasnikLige = res && res.data && res.data.vlasnikLige
                store.state.metadata.userData.groupOwner = res && res.data && res.data.groupOwner
                store.state.metadata.userData.avatar = res && res.data && res.data.avatar
                store.state.metadata.userData.activeUserDevice = res && res.data && res.data.activeUserDevice
                store.state.metadata.userData.usedBonus_wild_card = res && res.data && res.data.usedBonus_wild_card
                store.state.metadata.userData.usedBonus_times_three = res && res.data && res.data.usedBonus_times_three
                store.state.metadata.userData.usedBonus_plus_30_seconds = res && res.data && res.data.usedBonus_plus_30_seconds
            } catch (error) {
                console.error(error)
            }
            store.state.metadata.loaded = true
            return true
        }
    },
    async getMetadata () {
        try {
            if (store.state.authenticated) {
                await this.fetchMetadata()
                await this.checkForNextQuiz()
            }
        } catch (error) {
            console.log(error && error.message ? error.message : error)
            store.commit('setApplicationState', ApplicationState.NO_FUTURE_ROUND)
        }
    },
    checkForNextQuiz () {
        return new Promise(async (resolve, reject) => {
            try {
                let liga
                try {
                    if (!store.state.metadata.userData.liga) {
                        reject(new Error('User has no leauge'))
                    } else {
                        liga = store.state.metadata.userData.liga
                    }
                } catch (error) {
                    console.error(error)
                    reject(new Error('User has no leauge'))
                }
                this.shared.db().ref(`/qIndex/${liga}`).on('value', async (snapshot) => {
                    const currentTimestamp = Math.round(Date.now() / 1000) - store.state.timeDiff
                    let allQuizes = snapshot.val()
                    if (!allQuizes) {
                        allQuizes = []
                    }
                    // Loop until the future.
                    for (let i = 0; i < allQuizes.length; i++) {
                        let singleQuiz = allQuizes[i]
                        // Check for future quizz
                        if (singleQuiz.startTime > currentTimestamp || (singleQuiz.startTime < currentTimestamp && currentTimestamp < singleQuiz.endTime)) {
                            let hasPrevRound = false
                            // if there is a rouund before this one
                            if (i > 0 && allQuizes[i - 1]) {
                                hasPrevRound = true
                            }
                            // Get the next round
                            let key = singleQuiz.key
                            singleQuiz = await this.shared.db().ref(`quizess/${singleQuiz.key}`).once('value')
                            singleQuiz = singleQuiz.val()
                            singleQuiz.timeLength = singleQuiz.endTime - singleQuiz.startTime
                            singleQuiz.quizKey = key
                            // TODO, a better check here
                            if (store.state.round.startTime !== singleQuiz.startTime) {
                                store.commit('setRound', singleQuiz)
                            }
                            if (singleQuiz.startTime > currentTimestamp) {
                                store.commit('setApplicationState', ApplicationState.ROUND_STARTING)
                            } else if (singleQuiz.startTime < currentTimestamp && currentTimestamp < singleQuiz.endTime) {
                                store.commit('setApplicationState', ApplicationState.ROUND_IN_PROGRESS)
                            }
                            if (hasPrevRound) {
                                let prevQuiz = allQuizes[i - 1]
                                let prev = await this.shared.db().ref(`quizess/${prevQuiz.key}`).once('value')
                                prev = prev.val()
                                if (prev) {
                                    prev.quizKey = prevQuiz.key
                                    store.commit('setPrevRound', prev)
                                }
                                resolve(allQuizes)
                            }
                            resolve(true)
                            break
                        }
                        if (i === allQuizes.length - 1) {
                            let prevIndex = allQuizes[i]
                            let prev = await this.shared.db().ref(`quizess/${prevIndex.key}`).once('value')
                            prev = prev.val()
                            if (prev) {
                                prev.quizKey = prevIndex.key
                                store.commit('setPrevRound', prev)
                            }
                            // TODO: CHECK THIS PATH
                            // resolve(true)
                            // break
                        }
                    }
                    reject(new Error('no future quizz'))
                })
            } catch (error) {
                reject(new Error('Something went wrong'))
            }
        })
    },

    async searchUsers (searchedString) {
        try {
            const searchUsers = this.shared.functions().httpsCallable('searchUsers')
            let res = await searchUsers(searchedString)
            return res.data
        } catch (error) { }
        return false
    },
    async getUserData (uid) {
        try {
            const getUserData = this.shared.functions().httpsCallable('getUserData')
            let res = await getUserData(uid)
            return res.data
        } catch (error) {
            console.error(error)
        }
        return true
    },

    async setActiveDeviceToken () {
        try {
            if (store.state.user) {
                let uid = store.state.user.uid
                let deviceToken = store.state.user.refreshToken
                await this.shared.db().ref(`/users/${uid}/activeUserDevice`).set(deviceToken)
            }
        } catch (error) {
            console.error(error)
        }
    },

    async getUsername (uid) {
        try {
            if (!uid) {
                return this.$store.state.metadata.userData.name
            } else {
                const nameRef = await this.shared.db().ref(`/users/${uid}/name`).once('value')
                return nameRef.val()
            }
        } catch (error) {
            console.error(error)
        }
    },

    watchActiveDeviceToken () {
        try {
            if (store.state.user) {
                let uid = store.state.user.uid
                this.shared.db().ref(`/users/${uid}/activeUserDevice`).on('value', (snapshot) => {
                    store.state.metadata.userData.activeUserDevice = snapshot.val()
                })
            }
        } catch (error) {
            console.error(error)
        }
    }
}
